'use strict';
import isString from 'lodash/isString';

FileUtilities.$inject = [];

export function FileUtilities() {
  this.getExtension = getExtension;
}

// credit to VisioN for extension capture one-liner:
// http://stackoverflow.com/questions/190852/how-can-i-get-file-extensions-with-javascript,
export function getExtension(filename) {
  return isString(filename) ? filename.substr((~-filename.lastIndexOf(".") >>> 0) + 2) : '';
}

export function getBaseName(filename, ext) {
  if (!isString(filename)) {
    return '';
  } else if (!ext) {
    ext = getExtension(filename);
  }

  if (isString(ext) && ext.length > 0) {
    return filename.substr(0, filename.length - ext.length - 1);
  } else {
    return filename;
  }
}

export function appendToName(filename, append) {
  if (!isString(filename) || !isString(append)) {
    return filename;
  }

  const ext = getExtension(filename);
  const baseName = getBaseName(filename, ext);

  return ext ? `${baseName}${append}.${ext}` : `${baseName}${append}`;
}

export function truncateName(name, length) {
  if (isString(name) && name.length > length) {
    return name.substr(0, length - 1) + '\u2026';
  } else {
    return name;
  }
}



// WEBPACK FOOTER //
// ./src/js/core-utilities/upload-service/FileUtilities.js